import { render, staticRenderFns } from "./fontcolor.vue?vue&type=template&id=5c80a708&"
import script from "./fontcolor.vue?vue&type=script&lang=js&"
export * from "./fontcolor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports